module.exports = __webpack_public_path__ + "img/file-earmark-plus.0ac15984.svg";